var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalKindle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_63654",
    "data-name": "Group 63654",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_304",
    "data-name": "Ellipse 304",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#e3ebf1",
    strokeWidth: 1,
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17.5,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "noun-highlighter-1189390",
    transform: "translate(11.211 7.332)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12491",
    "data-name": "Path 12491",
    d: "M212.52,59.322c-2.47,4.05-5.247,8.191-7.316,12.057-.1.12-.076.176-.065.319.136,1.109.492,2.109.649,3.255q-.7,1.237-1.387,2.478c.824.172,1.872.4,2.588.5.307-.448.752-1.216,1.013-1.681a31.4,31.4,0,0,0,3.115-1.022c.152-.037.163-.108.243-.221,2.3-4.13,4.343-8.4,6.489-12.58a1.12,1.12,0,0,0-.446-1.53q-1.628-.958-3.253-1.922a1.2,1.2,0,0,0-1.63.344Zm.957.507c1.151.6,2.478,1.435,3.5,2.037-2.133,4.077-4.2,8.371-6.091,11.852l-4.364-2.544c2.295-4.051,4.841-7.989,6.959-11.345ZM206.3,72.263l3.812,2.217c-.8.287-1.689.557-2.149.7l-1.168-.679c-.137-.844-.352-1.563-.495-2.233Zm.576,2.887.422.237c-.269.468-.525.949-.787,1.415l-.5-.106c.358-.636.571-1.016.868-1.546Zm-2.458,3.231v1.047h12.977V78.381Z",
    transform: "translate(-204.401 -58.801)",
    fill: "#f60",
    stroke: "#f60",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalKindle);
export default __webpack_public_path__ + "static/media/totalKindle.61c956b2ff91884e190d51a275b4645d.svg";
export { ForwardRef as ReactComponent };